// Referece: https://stackoverflow.com/questions/68905909/react-link-with-bearer-token
// https://pastebin.com/raw/exLJqNLi

import { createRef } from 'react';
import { Card, CardBody, CardHeader, NavLink, Button } from "reactstrap";

import { axiosApi } from "../common/httpService";

const AuthLink = (props, children) => {
  const wrapper = createRef();

  const href = props.href || '';
  const target = props.target || '_blank';

  const handleAction = async e => {
    try {
      // Authorization header must have been set already in axiosApi.default
      const result = await axiosApi({
        url: href,
        method: "GET",
        responseType: "blob",
      });

      let _blob = new Blob(["Resource Not Found"], { type: 'text/plain' });
      if (result.status == 200) { _blob = result.data; }
      const _href = window.URL.createObjectURL(_blob);
      window.open(_href, target).focus();
    } catch (e) {
      console.log(`AuthLink handleAction Exception: ${href}, ${e}`);
      const _blob = new Blob([e], { type: 'text/plain' });
      const _href = window.URL.createObjectURL(_blob);
      window.open(_href, target).focus();
    }
  };

  return (
    <a style={{color: "#007bff", fontSize: "small"}} onClick={handleAction}>{props.value}</a>
  );
};

export default AuthLink;
